<template>
    <div id="wrap" class="skpfull_wrap">
        <div class="rd_box size1">
            <div class="container accountFrom">
				<div class="title">
					<h1>{{$t('SUBTITLE.EUR.REAPIR.GUIDE1')}}<br>{{$t('SUBTITLE.EUR.REAPIR.GUIDE2')}}</h1>
				</div>
                <!-- div class="subDesc">서브 설명 들어가는 곳</div -->
                <div class="account_wrap">
                    <div class="item">
                        <p class="item-dsec">{{$t('SUBTITLE.EUR.SIGN.IN.MSG1')}}<br>{{$t('SUBTITLE.EUR.SIGN.IN.MSG2')}}</p>
                        <div class="item-btn">
                            <button class="bt-type-b blue" @click="goSignInUp('I')">{{$t('TITLE.EUR.SIGN.IN')}}</button>
                        </div>
                        <p class="account_link"><a href="JavaScript:" @click="goSignInUp('U')">{{$t('BUTTON.EUR.CREATE.ACCOUNT')}}</a></p>
                    </div>
                    <div class="select_choose">
                        <fieldset class="ui_fieldset set_2">
                            <div>
                                <select class="slt_white w100p" id="countryCd" v-model="countryCd" @change="changeCountry">
                                    <option value="" selected>{{$t('FIELD.EUR.SELECT.COUNTRY')}}</option>
                                    <option v-for="code in countryCdList" :key="code.CODE" :value="code.CODE">{{code.CODE_NM}}</option>
                                </select>
                            </div>
                            <div>
                                <select class="slt_white w100p" id="langCd" v-model="langCd" @change="changeLanguage">
                                    <option value="" selected>{{$t('FIELD.EUR.SELECT.LANGUAGE')}}</option>
                                    <option v-for="code in langCdList" :key="code.CODE" :value="code.CODE">{{code.CODE_NM}}</option>
                                </select>
                            </div>
                        </fieldset>
                    </div>       
                </div>
			</div>
        </div>
        <div>
            <form id="samsungAccountForm" name='samsungAccountForm' action="" method="GET">
                <input type='hidden' id='response_type' name='response_type' value=''>
                <input type='hidden' id='client_id' name='client_id' value=''>
                <input type='hidden' id='locale' name='locale' value=''>
                <input type='hidden' id='countryCode' name='countryCode' value=''>
                <input type='hidden' id='redirect_uri' name='redirect_uri' value=''>
                <input type='hidden' id='state' name='state' value=''>
                <input type='hidden' id='goBackURL' name='goBackURL' value=''>
                <input type='hidden' id='scope' name='scope' value=''>			
            </form>
        </div>
    </div>
</template>

<script>

import Vue              from 'vue';
import { mapGetters }   from 'vuex';
import { SDLUtil }      from '@/utils';
import qs               from 'query-string';
import axios            from 'axios';
import store            from '@/vuex/store';
import { i18n, loadLanguageAsync } from '@/i18n';

export default {
    name: 'EurLoginUser',
    data() {
        return {
            params    : {},
            subTitle1 : '',
            subTitle2 : '',
            countryCd : '',
            langCd    : '',
            countryCdList: [],
            langCdList: []
        };
    },
    computed: {
        ...mapGetters({
            guid    : 'getGuid',
            loginId : 'getLoginId', // (=bpNo)
            email   : 'getEmail'
        }),
        getLoginUser() {
            return SDLUtil.getLoginedUserInfo();
        }
    },
    methods: {
        async goSignInUp(InUp) {
            if (!this.countryCd) {
                SDLUtil.alert('FIELD.EUR.SELECT.COUNTRY');
                return false;
            }
            if (!this.langCd) {
                SDLUtil.alert('FIELD.EUR.SELECT.LANGUAGE');
                return false;
            }

            // 국가,언어명 저장
            let countryNm = $('#countryCd option:selected').text();
            let langNm    = $('#langCd option:selected').text();
            localStorage.setItem('eur.user.country.name', countryNm);
            localStorage.setItem('eur.user.lang.name', langNm);
            SDLUtil.showLoadingBar(true);
            
            // 로그인..
            const param = {countryCd: this.countryCd, langCd: this.langCd};
            const url = `${SDLUtil.API_URL}/noauth/samsungAccountSignInUp.skp`;
            return await axios.post(url, qs.stringify(param))
                .then(resp => {
                    console.log('goSignInUp.resp ===> ', resp);
                    localStorage.setItem('eur.user.country.code', resp.data.countryCd);
                    localStorage.setItem('eur.user.lang.code', resp.data.langCd);
                    
                    $('form[name="samsungAccountForm"] input[name="response_type"]').val(resp.data.responseTypeSso);
                    $('form[name="samsungAccountForm"] input[name="client_id"]').val(resp.data.clientIdSso);
                    $('form[name="samsungAccountForm"] input[name="locale"]').val(resp.data.localeSso);
                    $('form[name="samsungAccountForm"] input[name="countryCode"]').val(resp.data.countryCodeSso);
                    $('form[name="samsungAccountForm"] input[name="redirect_uri"]').val(resp.data.redirectUriSso);
                    $('form[name="samsungAccountForm"] input[name="state"]').val(resp.data.stateSso);
                    $('form[name="samsungAccountForm"] input[name="goBackURL"]').val(resp.data.goBackURLSso);

                    if (InUp == 'I') $("#samsungAccountForm").attr("action", resp.data.signInGateUri); //signIn
                    else             $("#samsungAccountForm").attr("action", resp.data.signUpGateUri); //signUp
                    $('#samsungAccountForm').submit();
                })
                .catch(err => {
                    console.log('Err.login ==> ', err);
                    SDLUtil.showLoadingBar(false);
                    SDLUtil.errorAlert(err);
                });
        },
        getCommonCodes(groupCd) {
            const url = `${SDLUtil.API_URL}/noauth/eur/getNationLangCodes.skp`;
            return axios.post(url,
                qs.stringify({groupCd: groupCd}), {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            }).then(resp => {
                if (groupCd == 'N') { // Nations
                    this.countryCdList = resp.data.rows;

                    if (this.params.countryCd) {
                    	this.countryCd = this.params.countryCd;
                    }else{
                    	this.countryCd = '';
                    }

                } else { // Languages
                    this.langCdList    = resp.data.rows;
                    if (this.params.langCd) {
                        this.langCd = this.params.langCd;
                    }
                }
            }).catch(err => {
                console.log('CommonCodes.Error occured : ', err);
            });
        },
        // 국가 변경
        changeCountry() {
            const orgLang = this.langCd;
            this.countryCdList.forEach(elm => {
                if (elm.CODE == this.countryCd) {
                    this.langCd = elm.LANG_CD;
                    if (orgLang != this.langCd) {
                        this.changeLanguage();
                    }
                    return false;
                }
            });
        },
        // 언어 변경
        changeLanguage() {
            store.commit('LANG_CD', this.langCd);
            loadLanguageAsync(this.langCd);
        },
        getAccessToken(param) {
            SDLUtil.showLoadingBar(true);
            const url = `${SDLUtil.API_URL}/noauth/getAccessToken.skp`;
            return axios.post(url, qs.stringify(param), {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            }).then(resp => {
                const userInfo = resp.data;
                console.log('Login.getAccessToken.userInfo ==> ', userInfo);
                SDLUtil.showLoadingBar(false);
                store.commit('LOGIN_COUNTRY_CD', localStorage.getItem('eur.user.country.code'));
                store.commit('COUNTRY_CD',       localStorage.getItem('eur.user.country.code'));
                store.commit('COUNTRY_NM',       localStorage.getItem('eur.user.country.name'));
                store.commit('LANG_CD',          localStorage.getItem('eur.user.lang.code'));
                store.commit('GUID',    userInfo.guid);
                store.commit('EMAIL',   userInfo.email);
                store.commit('CORP_NO', userInfo.corpNo);

                // 정상 로그인(기등록자)
                if (userInfo.userDelYn == 'Y') { // 삭제된 회원
                    SDLUtil.alert('MESSAGE.EUR.ALERT.DEL.USER');
                } else if (userInfo.bpNo) { // 정상회원
                    store.commit('LOGIN_ID',    userInfo.bpNo);
                    store.commit('COUNTRY_CD',  userInfo.countryCd);
                    store.commit('COUNTRY_NM',  userInfo.countryNm);
                    localStorage.setItem('eurUser', 'Y');
                    let pathUrl = `${SDLUtil.WEB_CONTEXT_PATH}/erp/repairInfoHist`;
                    this.$router.push({ path: pathUrl, query: {}});
                } else if (userInfo.resCode == 'F') { // RFC 오류 발생
                    SDLUtil.alert(userInfo.resMsg);
                } else { // 미등록자 -> 사용자(부가정보) 등록
                    const pathUrl = `${SDLUtil.WEB_CONTEXT_PATH}/erp/joinUserStep1`;
                    this.$router.push({ path: pathUrl, query: {}});
                }
            }).catch(err => {
                console.log('EurLoginUser.getAccessToken Error occured : ', err);
            });
        }
    },
    created() {
        store.commit('LOGIN_ID',  null);
        localStorage.removeItem('eurUser');
    },
    mounted() {
        this.params = this.$route.query;
        let langCd  = this.params.langCd;        
//        this.$router.push({ path: `${SDLUtil.WEB_CONTEXT_PATH}/erp/wait`, query: {pageMode: 'UC'});
        // 2021.01.14 MATI
        if (SDLUtil.isMobile()) {
            store.commit('LANG_CD', langCd);
            loadLanguageAsync(langCd);
//            SDLUtil.alert('This system can only be used in PC environment and cannot be used on mobile.');
            this.$router.push({ path: `${SDLUtil.WEB_CONTEXT_PATH}/erp/wait`, query: {pageMode: 'PO'}});
//            return;
        }

        if (this.params.passwd) {
            localStorage.setItem('eur.user.password', this.params.passwd);
        }

        if (!langCd) {
            langCd = localStorage.getItem('eur.user.lang.code');
        }
        if (langCd) {
            store.commit('LANG_CD', langCd);
            loadLanguageAsync(langCd);
        }

        $('body').addClass('reaair_wrap');
        if (this.params.state && this.params.state.length > 9 && this.params.code && this.params.code.length > 9) {
            this.$nextTick(() => {
//                let passwd = localStorage.getItem('eur.user.password');
//                console.log('Login.passwd ===> ', passwd);
//                if (passwd === 'CADILAC') 
                this.getAccessToken(this.params);
//                else    SDLUtil.alert('Access denied due to System Test.');
            });
        }
        this.getCommonCodes('N'); // Country
        this.getCommonCodes('L'); // Language
    },
    watch: {
        errorState() {
            alert(this.errorState.code);
            this.$router.push({ path: `${SDLUtil.WEB_CONTEXT_PATH}/error` });
        },
    },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/eur/EurLoginUser.vue